import React from 'react';
import { Button, Form } from 'antd';
import CustomAccordion from '../CustomAccordion';
import GrossRentHistory from './GrossRentHistory';
// import AdvanceAmountHistory from './AdvanceAmountHistory';
import pdfIcon from 'assets/images/icons/pdf_red.svg';
import pdfIconDisable from 'assets/images/icons/pdf_white.svg';
import CardAccordion from '../../CardAccordion';

const LeaseHistory = ({ viewData, selectHistory }) => {
	const form = Form.useFormInstance();
	const grossRentListSet = form.getFieldValue('grossRentListSet');

	// const advanceAmountListSet = form.getFieldValue('advanceAmountListSet');

	return (
		<>
			<CustomAccordion
				title="Lease Payment Schedule"
				customHeaderSX={{
					backgroundColor: '#e1f0ff !important',
					p: '10px',
				}}
				typographySX={{ fontSize: '16px !important' }}
				darkTitle={true}
				sx={{ mb: 2 }}
			>
				{grossRentListSet?.map((item, index) => (
					<GrossRentHistory key={index} data={item} index={index} />
				))}
			</CustomAccordion>
			<CardAccordion
				title="Other Changes History"
				customHeaderSX={{
					backgroundColor: '#e1f0ff !important',
					p: '10px',
				}}
				typographySX={{ fontSize: '16px !important' }}
				darkTitle={true}
				sx={{ mb: 2 }}
			>
				<Button
					type="primary"
					style={{
						fontSize: '13px',
						fontWeight: '500',
						borderRadius: '6px',
						marginRight: '3px',
						display: 'flex',
						alignItems: 'center',
						gap: '6px',
						...(viewData?.history?.length === 0 ? { backgroundColor: '#6c757d' } : {}),
					}}
					onClick={(e) => {
						e.stopPropagation();
						if (selectHistory) {
							selectHistory({ ...viewData, ...viewData?.data, id: viewData?._id });
						} else if (viewData?.selectHistory) {
							viewData.selectHistory({ ...viewData, ...viewData?.data, id: viewData?._id });
						}
					}}
				>
					<img src={viewData?.history?.length > 1 ? pdfIcon : pdfIconDisable} width={16} height={16} alt="view" />
					Log
				</Button>
			</CardAccordion>
		</>
	);
};

export default LeaseHistory;
